import * as amplitude from "@amplitude/analytics-browser";

import { getConfig } from "../config/config";
import { PreviewPageEnv } from "../constants/PreviewPageEnv";

interface IAmplitudeService {
  instance?: amplitude.Types.AmplitudeReturn<void>;
  logToConsole?: boolean;
}

const service: IAmplitudeService = {};

export enum AmplitudeEventProperty {
  SourceName = 'Source Name',
}

const sourceName = 'LiveChat:PreviewPage';

const sourceNamePlugin = (): amplitude.Types.EnrichmentPlugin => {
  return {
    // eslint-disable-next-line @typescript-eslint/require-await
    execute: async (event: amplitude.Types.Event) => {
      event.event_properties = {
        ...event.event_properties,
        [AmplitudeEventProperty.SourceName]: sourceName,
      };

      return event;
    },
  };
};

export const initAmplitude = () => {
  const env: PreviewPageEnv =
    window.location.href.indexOf("labs") > -1
      ? PreviewPageEnv.Labs
      : window.location.href.indexOf("staging") > -1
      ? PreviewPageEnv.Staging
      : PreviewPageEnv.Production;

  const { amplitudeKey, amplitudeQueue } = getConfig(env);

  service.instance = amplitude.init(amplitudeKey, {
    useBatch: false,
    serverUrl: amplitudeQueue,
    defaultTracking: {
      pageViews: false,
    },
  });
  amplitude.add(sourceNamePlugin());

  service.logToConsole = env !== PreviewPageEnv.Production;
};

export const trackEvent = (eventName: string, eventProperties = {}) => {
  if (!service.instance) {
    return;
  }

  amplitude.logEvent(eventName, eventProperties);

  if (service.logToConsole) {
    console.log(
      "[APP_EVENT]",
      eventName,
      "Properties:",
      JSON.stringify(eventProperties)
    );
  }
};
